<cm-overlay
  [header]="(currentCustomer$ | async).assistance_menu_label"
  [width]="800"
  [height]="600"
  >
  @if (assistanceProviderChoices$ | async; as choices) {
    <cm-choice-selector
      [choices]="choices"
      (choiceSelected)="sendAssistanceRequest($event)"
      [choiceWidth]="600"
      [showAvatar]="false"
      [avatarSize]="50"
    ></cm-choice-selector>
  } @else {
    <h1 class="confirmation">{{ noProvidersMessage }}</h1>
  }

</cm-overlay>
